import { atom } from "recoil";

export const authState = atom({
  key: "auth", // unique ID (with respect to other atoms/selectors)
  default: {}, // default value (aka initial value)
});
